import Add from '@mui/icons-material/Add'
import { Button } from '@mui/material'

export default function RecommendationAdditionActions({ createRecommendation }) {
  return (
    <div className="d-flex align-items-center gap-2">
      <Button
        startIcon={<Add />}
        color="inherit"
        variant="outlined"
        size="small"
        sx={{ textTransform: 'none', border: '1px solid #ebebeb', borderRadius: '8px'}}
        onClick={() => {
          createRecommendation('THERAPY')
        }}
      >
        Therapy
      </Button>
      <Button
        startIcon={<Add />}
        color="inherit"
        variant="outlined"
        size="small"
        sx={{ textTransform: 'none', border: '1px solid #ebebeb', borderRadius: '8px'}}
        onClick={() => {
          createRecommendation('DIAGNOSTIC_ASSESSMENT')
        }}
      >
        Assessment
      </Button>
      <Button
        startIcon={<Add />}
        color="inherit"
        variant="outlined"
        size="small"
        sx={{ textTransform: 'none', border: '1px solid #ebebeb', borderRadius: '8px'}}
        onClick={() => {
          createRecommendation('DIETICIAN_CONSULTATION')
        }}
      >
        Dietician consult
      </Button>
    </div>
  )
}
